import React, { useEffect } from 'react';
import { Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
const ScheduleModal = ({ open, onClose, onConfirm, order }) => {
  // Early return if order is null or undefined

  if (!order) {
    return null;
  }

  const handleConfirm = () => {
    onConfirm(order);  // Call the function passed from the parent component
    onClose(); // Close the modal after confirmation
  };

  return (
    <Modal 
      open={open} 
      onClose={onClose}
      onClick={(e) => {
        // Only close if clicking on the backdrop (not the modal content)
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div 
        className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-10"
        onClick={(e) => e.stopPropagation()}
      >
        <div 
          className="bg-white rounded-lg shadow-lg max-w-sm w-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className='px-4 py-3 bg-[#E179544A] flex justify-between rounded '>
            <h3 className="text-lg font-semibold cursor-pointer text-left">Confirm Schedule</h3>
            <CloseIcon sx={{cursor:'pointer'}} onClick={onClose} />
          </div>
          <div className='p-4'>
            <p className="mt-4">
              Are you sure you want to change the schedule from{' '}
              {order.schedule === 't' ? 'Schedule' : 'Today'} to{' '}
              {order.schedule=== 't' ? 'Today' : 'Schedule'}?
            </p>
            <div className="mt-6 flex justify-between">
              <button onClick={onClose}  className="w-24 bg-gray-100 rounded">
                Cancel
              </button>
              <button onClick={handleConfirm}  className="w-24 px-2 py-2 rounded text-white bg-[#E17954]">
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ScheduleModal;
